/**
 * Fix common copy/paste issues so CRS parsers accept the string.
 * JSON / config dumps often use escaped quotes: PROJCS[\"name\",...] — WKT requires ".
 */
export function normalizeWktInput(raw) {
  let s = String(raw ?? '').trim();
  if (!s) return s;
  // JSON-style escaped double quotes (most common issue)
  s = s.replace(/\\"/g, '"');
  // If the whole value was wrapped as a JSON string, strip one level
  if (s.length >= 2 && s.startsWith('"') && s.endsWith('"')) {
    try {
      const parsed = JSON.parse(s);
      if (typeof parsed === 'string') s = parsed.trim();
    } catch (_) {
      /* keep s */
    }
  }
  return s.trim();
}
